import {
  TRASH_SOFTSKILLS_COURSE,
  TRASH_SOFTSKILLS_COURSE_SUCCESS,
  TRASH_SOFTSKILLS_COURSE_CLEAN,
  TRASH_SOFTSKILLS_COURSE_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  course: undefined,
}

const SoftskillCourseTrash = (state = initialState, action) => {
  switch (action.type) {
    case TRASH_SOFTSKILLS_COURSE:
      state = {
        ...state,
        loading: true,
      }
      break
    case TRASH_SOFTSKILLS_COURSE_SUCCESS:
      state = {
        ...state,
        course: action.payload.course,
        loading: false,
        done: true,
      }
      break
    case TRASH_SOFTSKILLS_COURSE_CLEAN:
      state = initialState
      break
    case TRASH_SOFTSKILLS_COURSE_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SoftskillCourseTrash
